import { useContext, ref, Ref } from '@nuxtjs/composition-api';
interface Jwt {
  user: {
    id: string;
    accountId: string;
    email: string;
    firstName: string;
    lastName: string;
    locale: string;
  };
  engagementMedium: string;
  widgetType: string;
  jwt: string;
}

interface UseSaasqutach {
  getJwt: (userId: string) => Promise<Jwt | undefined>;
  validateReferralCode: () => Promise<boolean>;
  referralCode: Ref<string | undefined>;
  referralCodeError: Ref<string | undefined>;
}

export const useSaasquatch = (): UseSaasqutach => {
  const { $axios, $config } = useContext();
  const referralCode = ref<string | undefined>(undefined);
  const referralCodeError = ref<string | undefined>(undefined);

  const getJwt = async (userId: string): Promise<Jwt | undefined> => {
    try {
      const response = await $axios.put(`/private/v1/saasquatch/user/${userId}/jwt`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const validateReferralCode = async (): Promise<boolean> => {
    try {
      const normalisedReferralCode = referralCode.value?.trim();
      if (!normalisedReferralCode) {
        referralCodeError.value = 'Please enter a referral code';
        return false;
      }

      referralCode.value = normalisedReferralCode;
      referralCodeError.value = undefined;
      const response = await $axios.get(
        `${$config.saasquatchBaseUrl}/api/v1/${
          $config.saasquatchTenantAlias
        }/open/code/${encodeURIComponent(normalisedReferralCode)}`
      );
      if (response.status === 200) {
        return true;
      }
      throw new Error('Invalid referral code, none 200 response code');
    } catch (error) {
      console.error(error);
      referralCodeError.value = `Referral code ${referralCode.value} not found`;
      return false;
    }
  };

  return {
    getJwt,
    validateReferralCode,
    referralCode,
    referralCodeError,
  };
};
